// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"Price_priceContainer__uHqt6","isDiscounted":"Price_isDiscounted__2INf1","price":"Price_price__3xeHF"};